import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";

const ROLE_TO_COLUMN: Record<string, string> = {
  "Director": "pp_edit_project__project_director",
  "Manager": "pp_edit_project__project_manager",
};

export const useEditProjectAccess = (user: User | null) => {
  const [canEditProject, setCanEditProject] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const { data: userRow } = await supabase
          .from("users")
          .select("role, company_name")
          .eq("email", user.email)
          .maybeSingle();

        const role = userRow?.role ?? null;
        const companyName = userRow?.company_name ?? null;
        const column = role ? ROLE_TO_COLUMN[role] : undefined;

        if (!column || !companyName) {
          setCanEditProject(true);
          return;
        }

        const { data: permRow } = await supabase
          .from("project_access_permissions")
          .select(column)
          .eq("company_name", companyName)
          .maybeSingle();

        if (!permRow) {
          setCanEditProject(true);
          return;
        }

        const value = (permRow as unknown as Record<string, unknown>)[column];
        setCanEditProject(value !== false);
      } catch (e) {
        console.error("useEditProjectAccess error", e);
        setCanEditProject(true);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [user?.email]);

  return { canEditProject, loading };
};
